import { BUBBLETAP_TEL } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function PrivacyPolicyJa() {
  return (
    <Styled.MainWrapper>
      <h3>株式会社BubbleTap 個人情報保護方針</h3>
      <p>第1条 個人情報保護方針とは？</p>
      <ol>
        ① 個人情報の収集
        <br />
        株式会社BubbleTap（以下「当社」といいます）は、利用者の個人情報を重要視しています。当社が利用者に対して提供するTingle、リワード(Reward)など（以下「サービス」といいます）を利用者が利用する際に、オンライン上で当社に提供された個人情報が保護されるよう、最善を尽くしています。このため、当社は個人情報の保護に関する法律、通信秘密保護に関する法律、電気通信事業に関する法律、情報通信網利用促進等に関する法律など、情報通信サービス提供者が遵守すべき関連法規上の個人情報保護規定を遵守しています。
        <br />
        <br />
        サービス提供に必要な最小限の個人情報を、以下の各号で収集しています。すべての利用者は当社が提供するサービスを利用でき、会員登録を通じてより多様なサービスを受けることができます。利用者の個人情報を収集する場合、必ず事前に利用者に対しその事実を通知し、同意を求めます。以下の各号に掲げるように、必要最小限の個人情報を収集しており、利用者の同意なしに機微な情報を収集しません。
        <br />
        <br />- 必須情報：当該サービスの基本的な機能を実行するために必要な情報
        <br />- 選択情報：より専門的なサービスを提供するために追加で収集する情報
        <br />
        <br />
        <li>
          Tingle、リワード
          <ol>
            <li>必須：外部アカウント連携情報（Google、Kakao、Appleのうち、ユーザーが選択した情報）、ID</li>
            <li>選択：メールアドレス、プロフィール写真、ソーシャルログインプロバイダー、ニックネーム</li>
          </ol>
        </li>
        <li>
          アカウント情報検索
          <ol>
            <li>必須：ソーシャルID、ID、メールアドレス</li>
          </ol>
        </li>
        <li>
          決済および有料サービス利用
          <ol>
            <li>必須：決済日時、決済方法、決済ストア、決済金額、決済通貨、決済IP、Google・Apple決済ID</li>
          </ol>
        </li>
        <li>
          Tingle リワード インセンティブ プログラム
          <ol>
            <li>
              必須：ソーシャルID、ユーザーID、氏名、その他識別情報、口座名義人名、銀行名、口座番号、売上が発生した場合のその他識別情報
            </li>
          </ol>
        </li>
        <li>
          コンテンツ（利用規約第2条第2項参照）の利用
          <ol>
            <li>必須：利用コンテンツ、利用日時、購入日時</li>
          </ol>
        </li>
        <li>
          マーケットプレイス 個人販売者
          <ol>
            <li>
              必須：ソーシャルID、ユーザーID、氏名、メールアドレス、電話番号、未成年販売者の場合法定代理人情報（氏名、販売者との関係、生年月日、住所、電話番号、メールアドレス、身分証明書コピー、家族関係を証明する書類、売上が発生した場合のその他識別情報、口座情報（口座名義人、銀行名、口座番号）
            </li>
          </ol>
        </li>
        <li>
          マーケットプレイス個人・法人事業者
          <ol>
            <li>
              必須：ソーシャルID、ユーザー名、氏名、メールアドレス、代表者名、電話番号、事業所住所、担当者氏名/電話番号/メールアドレス、口座情報（口座名義人、銀行名、口座番号）、提出書類（事業者登録証、印鑑証明書、代表者名通帳のコピー、入金口座届出書、使用印鑑証明書）
            </li>
          </ol>
        </li>
        <li>
          コンテスト応募
          <ol>
            <li>
              必須：ニックネームまたはID、（14歳以上の場合）電話番号、（15歳未満の閲覧不可コンテンツを登録する場合）本人認証情報（氏名、生年月日、性別、メールアドレス、口座番号、内/外国人情報、携帯電話番号、携帯電話事業者情報、暗号化された同一者識別情報（CI））
            </li>
          </ol>
        </li>
        <li>
          本人認証
          <ol>
            <li>
              必須：携帯電話本人確認のための氏名、生年月日、性別、内/外国人情報、携帯電話番号、携帯電話事業者情報、暗号化された同一者識別情報（CI）、重複加入確認情報（DI）
            </li>
          </ol>
        </li>
        <li>
          イベント応募および当選
          <ol>
            <li>必須：氏名、住所、携帯電話番号、メールアドレス、その他識別情報</li>
          </ol>
        </li>
        <li>
          カスタマーセンター
          <ol>
            <li>必須：携帯電話番号、ソーシャルID、ID、メールアドレス</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② サービス利用過程で自動的に生成または収集される情報
        端末情報（モデル名、デバイスID、MACアドレス、OS）、IPアドレス、クッキー、接続ログ、不正利用記録、サービス利用記録などの情報が自動的に生成され、収集される場合があります。
        <br />
        <br />
        ③ 個人情報収集方法
        <br />
        個人情報を収集する場合、必ず事前に利用者にその事実を通知し、同意を得ており、以下の方法を通じて個人情報を収集します。
        <ol>
          <li>会員登録およびサービス利用の過程で利用者が個人情報の収集に同意する場合</li>
          <li>当社が運営するソーシャルメディアアカウントを通じて、当該ソーシャルメディア事業者から提供を受けた場合</li>
          <li>提携サービスまたは団体などから個人情報を提供を受けた場合</li>
          <li>ウェブページ、メール、FAX、電話でカスタマーセンターで相談する場合</li>
          <li>オンライン・オフラインで実施されるイベント/行事に参加する場合</li>
        </ol>
      </ol>
      <p>第2条 個人情報の利用</p>
      利用者の個人情報は、以下の目的のみに利用し、目的が変更される場合は、必ず事前に利用者の同意を得るものとします。
      <br />
      <br />
      ① 会員の識別/会員登録の意思確認、不正利用防止、本人確認および認証、苦情処理、紛争解決
      <br />
      ② 活動履歴の通知機能の提供
      <br />
      ③
      人口統計学的特性と利用者の興味、好み、傾向の推定に基づくカスタマイズされたコンテンツの推薦およびマーケティングへの活用
      <br />
      ④
      新規サービス開発および利用者向けカスタマイズサービス提供、多様なサービス提供、お問い合わせや苦情処理、お知らせの伝達
      <br />
      ⑤ 有料またはリワードサービス利用時、コンテンツ等の送信や配送・料金精算およびそのための本人認証、年齢認証、口座認証
      <br />
      ⑥ サービスの円滑な運営を妨げる行為（アカウントの不正利用を含む）の防止および制裁
      <br />
      ⑦ イベント/行事への参加確認、マーケティングおよび広告に活用
      <br />
      ⑧
      サービス利用記録、アクセス頻度およびサービス利用に関する統計、プライバシー保護の観点からのサービス環境構築、カスタマイズ・パーソナライズサービス提供、サービス改善に活用
      <br />
      ⑨ ハッキング、詐欺などに関連する事故の調査およびその他の法令上の義務履行に伴う正当かつ合法的な捜査要請時の資料提供
      <br />
      <p>第3条 個人情報の保有および提供</p>
      ①
      ユーザーの退会請求または個人情報の収集および利用目的が達成されるまで保存し、その後、当該情報を遅滞なく破棄します。
      <br />
      ② 当社の個人情報処理方針に従い、以下の理由により、会員退会後も明示された期間、当該情報を保存します。
      <br />
      <br />
      <ol>
        <li>
          サービス利用に関する個人情報（ログイン記録）
          <ol>
            <li>保存根拠：関連法令（通信の秘密保護に関する法規）</li>
            <li>保管期間：3ヶ月</li>
          </ol>
        </li>
        <li>
          反復的な退会/再加入防止のための情報
          <ol>
            会員が退会した場合、再加入や任意の解約を反復的に行うことにより、当社が提供するサービスの不正利用やイベント特典などの利益を不正・不法に取得したり、その過程で名義盗用などの懸念があるため、このような行為を防止する目的で、会員退会後1ヶ月間会員情報を保管します。
            <li>保管根拠：当社内部方針（再加入、任意解約などの不正利用防止）</li>
            <li>保管期間：1ヶ月</li>
          </ol>
        </li>
      </ol>
      <br />
      ③ 個人情報の収集および利用に関する同意を拒否する権利があり、同意を拒否した場合、サービス利用ができません。
      <br />
      ④
      利用者の別途の同意がある場合、法令に規定された場合、利用者またはその法定代理人が意思表示をすることができない状態にある場合、または住所不明などにより事前の同意を得ることができない場合を除き、利用者の個人情報を利用者または第三者の緊急の生命、身体、財産の利益を保護するために必要であると認められる場合を除き、利用者の個人情報を第三者に提供しません。第三者とのサービス連携のため個人情報を提供する場合は、事業者名、目的、提供項目、および個人情報の保有・利用期間を本規約に明示いたします。
      <br />
      <br />
      また、サービス提供のため、以下の業務を委託しており、委託を受けた事業者が関係法令を遵守するよう管理・監督しています。委託契約締結時、個人情報保護の関連法に基づき、委託業務の目的外での個人情報処理の禁止、技術的・管理的な保護措置、再委託の制限、受託者に対する管理・監督、損害賠償等に関する事項を契約書等文書に明示します。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>国内委託先企業名</th>
              <th>委託業務内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>NAVERクラウド株式会社</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>株式会社アデナソフトウェア</td>
              <td>
                サービス開発および保守
                <br />
                システム運用および管理
                <br />
                データ保管
              </td>
            </tr>
            <tr>
              <td>株式会社トスペイメンツ</td>
              <td>電子決済代行</td>
            </tr>
            <tr>
              <td>ヘクトファイナンシャル株式会社</td>
              <td>電子決済代行</td>
            </tr>
            <tr>
              <td>株式会社ペイレター</td>
              <td>電子決済代行</td>
            </tr>
            <tr>
              <td>株式会社ポートワン</td>
              <td>本人認証代行</td>
            </tr>
            <tr>
              <td>NAVER Corporation</td>
              <td>サービス利用分析</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>国外委託先企業名</th>
              <th>委託業務内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amazon Web Service, Inc</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>
                Alphabet Inc.
                <br />
                Google Payment Korea
              </td>
              <td>
                サービス提供および分析のためのインフラ管理
                <br />
                アプリ内課金の処理
              </td>
            </tr>
            <tr>
              <td>Meta Platforms Inc.</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>Apple Inc.</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>Anthropic PBC</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>OpenAi Inc.</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>Razer Merchant Services Sdn. Bhd.</td>
              <td>海外電子決済代行</td>
            </tr>
            <tr>
              <td>Airbridge Pte. Ltd.</td>
              <td>アプリのエントリビューションおよびサービス利用分析</td>
            </tr>
            <tr>
              <td>Microsoft Corporation</td>
              <td>サービス提供および分析のためのインフラ管理</td>
            </tr>
            <tr>
              <td>X Corp.</td>
              <td>広告コンバージョントラッキング</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>第4条 情報主体としての権利、義務およびその行使方法 </p>
      利用者は個人情報主体として、以下の権利を行使することができます。
      <br />
      <br />
      <ol>
        ①
        利用者は、当社に対していつでも個人情報の閲覧、誤りがある場合の変更、削除、処理停止の請求などの権利を行使することができます。
        <br />
        <br />
        ②
        利用者は、当社に対して、①の権利の行使を個人情報保護等の関係法令に基づき、書面、電子メール、FAX等を通じて行うことができ、当社はこれに対し遅滞なく対応いたします。
        <br />
        <br />
        ③
        利用者は、①項の権利行使を、利用者の法定代理人または委任を受けた者等の代理人を通じて行うことができます。この場合、個人情報保護等の関係法令に従った委任状を提出する必要があります。
        <br />
        <br />
        ④
        当社は、利用者の権利に基づく閲覧の請求、訂正・削除の請求、処理停止の請求の際、請求を行った者が本人または正当な代理人であるかを確認します。
        <br />
        <br />
        ⑤
        利用者がまたは法定代理人が個人情報の誤り等に関する訂正を請求した場合、当社は訂正または削除が完了するまで当該個人情報を利用または提供しません。また、誤った個人情報を第三者に遅滞なく通知し、訂正が実施されるよう努めます。
        <br />
        <br />
        ⑥
        当社は、利用者または法定代理人により解除または削除された個人情報を、第3条「個人情報の保有および利用期間」に明示されたとおりに処理し、その他の目的で閲覧または利用できないよう措置いたします。
        <br />
        <br />
        ⑦
        利用者の個人情報の閲覧および処理停止の要求時、個人情報保護等の関係法令に基づき、利用者の権利が制限される場合があります。
        <br />
        <br />
        ⑧
        利用者または法定代理人が個人情報の訂正または削除を請求する場合、他の法令においてその個人情報が収集の対象として明示されている場合は、その削除を請求することはできません。
        <br />
        <br />⑨
        利用者は、個人情報保護等の関係法令に違反して、当社が処理している利用者本人または他者の個人情報およびプライバシーを侵害してはなりません。
      </ol>
      <p>第5条 個人情報の廃棄</p>
      個人情報は、収集および利用の目的が達成された場合、遅滞なく再生不可能な方法で廃棄します。また、『個人情報有効期間制』に基づき、1年間サービスを利用しなかった会員の個人情報を別途分離保管しており、分離保管された個人情報は4年間保管後、遅滞なく廃棄します。
      <br />
      <br />
      これ以外に、法令に基づき一定期間保管しなければならない個人情報および該当する法令は、以下の表のとおりです。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>保管情報</th>
              <th>保管理由</th>
              <th>保管期間</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                保管期間契約または申込の撤回等
                <br />
                に関する記録
              </td>
              <td>
                電子商取引等における消費者保護
                <br />
                に関する法律
              </td>
              <td>5年</td>
            </tr>
            <tr>
              <td>
                代金決済および商品等の供給に関
                <br />
                する記録
              </td>
              <td>
                電子商取引等における消費者保護
                <br />
                に関する法律
              </td>
              <td>5年</td>
            </tr>
            <tr>
              <td>
                消費者苦情または紛争処理に関
                <br />
                する記録
              </td>
              <td>
                電子商取引等における消費者保護
                <br />
                に関する法律
              </td>
              <td>3年</td>
            </tr>
            <tr>
              <td>表示/広告に関する記録</td>
              <td>
                電子商取引等における消費者保護
                <br />
                に関する法律
              </td>
              <td>6ヵ月</td>
            </tr>
            <tr>
              <td>
                税法が定めるすべての取引に関す
                <br />
                る帳簿及び証憑書類
              </td>
              <td>国税基本法（日本の国税通則法に該当）</td>
              <td>5年</td>
            </tr>
            <tr>
              <td>サービス利用に関するログイン記録</td>
              <td>通信秘密保護法（日本では憲法第21条および電気通信事業法第4条に相当）</td>
              <td>3ヵ月</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>第6条 その他</p>
      ①
      いつでも自身の個人情報を閲覧または修正することができ、収集・利用に関する同意の撤回または会員解約を請求することもできます
      <br />
      <br />
      ②
      14歳未満の児童の個人情報は、法定代理人の請求がある場合、法令上の権利（児童の個人情報に関する閲覧、訂正・削除、個人情報処理停止請求権）を保障します。
      <br />
      <br />
      インターネットサービスを通じて、顧客の情報を保存し随時取得するクッキー（cookie）を設置・運用しています。
      <ol>
        <li>
          使用目的
          <ol>
            <li>
              クッキーとは、ウェブサイトを運営するサーバーが利用者のブラウザに送信する非常に小さなテキストファイルで、利用者のハードディスクに保存されます。当社は、個人化されカスタマイズされたサービスを提供するため、利用者の情報を保存し随時呼び出すこのクッキーを使用します。また、利用者のウェブサイト訪問記録や利用形態を通じて最適化された広告など、カスタマイズされた情報を提供するために活用されます。
            </li>
          </ol>
        </li>
        <li>
          クッキーの収集拒否
          <ol>
            <li>
              クッキーには、名前や電話番号など個人を特定する情報は保存されません。利用者はクッキーの設置に関する選択権を有しています。第6条第3項第3号の方法でクッキーの設置を拒否できますが、これを拒否した場合、ウェブ利用が不便になり、ログインが必要な一部のサービス利用に支障が生じる可能性があります。
            </li>
          </ol>
        </li>
        <li>
          クッキーの収集拒否方法
          <ol>
            <li>Internet Explorer: [設定] → [インターネットオプション] → [個人情報] → [詳細設定]</li>
            <li>Chrome: [設定] → [個人情報とセキュリティ] → [サイト設定] → [クッキーとその他のサイトデータ]</li>
            <li>Edge: [設定] → [クッキーとサイト権限] → [クッキーとサイト権限]</li>
            <li>Safari: [環境設定] → [個人情報] → [クッキーとウェブサイトのデータレベル]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ④ 当社は、利用者のADID/IDFAを収集することがあります。
        <br />
        <br />
        <li>
          収集目的
          <ol>
            <li>
              ADID/IDFAとは、モバイルアプリ利用者の広告識別値であり、利用者のカスタマイズされたサービス提供やより良い環境の広告を提供するため、測定および収集しています。
            </li>
          </ol>
        </li>
        <li>
          拒否方法
          <ol>
            <li>Android: [設定] → [Google（Google設定）] → [広告] → [広告のカスタマイズ設定]</li>
            <li>iOS: [設定] → [プライバシー] → [広告] → [広告追跡制限]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ⑤ 当社は、利用者の重要な個人情報の保護のため、以下の取り組みを行っています。
        <li>
          当社は、利用者の個人情報を暗号化された通信経路を利用して送信し、パスワードなどの重要情報は暗号化して保管しています。
        </li>
        <li>
          当社は、ハッキングやコンピュータウイルスなどにより利用者の個人情報が漏洩したり損傷したりするのを防ぐため、外部からのアクセスが制限された区域にシステムを設置しています。ハッカーなどの侵入を検知し遮断できるシステムを設置し24時間監視しており、アンチウイルスプログラムを設置してシステムが最新の悪意のあるコードやウイルスに感染しないよう努めています。また、新しいハッキング/セキュリティ技術について継続的に研究し、サービスに適用しています。
        </li>
        <li>
          当社は、個人情報を取り扱う従業員を最小限に抑えています。また、個人情報を保管するデータベースシステムと個人情報を処理するシステムに関するパスワードの生成・変更、およびアクセス権限に関する体系的な基準を整備し、継続的な監査を実施しています。
        </li>
        <li>
          個人情報を取り扱うすべての従業員を対象に、個人情報保護の義務とセキュリティに関する定期的な教育を実施しています。
        </li>
        <li>
          当社は、個人情報保護のため、定期的な内部監査を実施しています。また、個人情報処理システムへのアクセス記録を保管・管理しており、アクセス記録が改ざんや盗難、紛失されないようセキュリティ機能を使用しています。
        </li>
      </ol>
      ⑥ 個人情報保護に関するお問い合わせは、以下の連絡先までご連絡ください。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>個人情報保護責任者</th>
              <th>担当部署</th>
              <th>お問い合わせ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>パク・ヨンウン</td>
              <td>BubbleTapチーム</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      また、個人情報が侵害された場合、その報告や相談が必要な場合は、以下の機関にお問い合わせいただき、支援を受けることができます。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>区分</th>
              <th>連絡先</th>
              <th>サイトのURL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>個人情報侵害通報センター</td>
              <td>（市外局番なし）118</td>
              <td>https://privacy.kisa.or.kr</td>
            </tr>
            <tr>
              <td>大検察庁 サイバー捜査課</td>
              <td>（市外局番なし）1301</td>
              <td>https://spo.go.kr</td>
            </tr>
            <tr>
              <td>警察庁 サイバー安全局</td>
              <td>（市外局番なし）182</td>
              <td>https://ecrm.police.go.kr</td>
            </tr>
            <tr>
              <td>個人情報紛争調整委員会</td>
              <td>（市外局番なし）1833-6972</td>
              <td>https://www.kopico.go.kr</td>
            </tr>
          </tbody>
        </table>
      </div>
      ⑦ 個人情報処理方針が変更される場合
      法律やサービスの変更事項を反映する目的などにより、個人情報処理方針を修正する場合があります。個人情報処理方針が変更される場合、変更内容を掲載し、変更された個人情報処理方針は変更内容を掲載した日から7日後に効力を発します。ただし、収集する個人情報の項目、利用目的の変更など、利用者の権利に重大な変更が生じる場合には、最低30日前までに事前に通知いたします。
      <br />
      <br />
      {/* 公告日・施行日は必要に応じて追記 */}
    </Styled.MainWrapper>
  );
}
